import {fetchMessages, fetchInitials} from "../../api/methods/messages";
import uniq from 'lodash.uniq';
import {EventBus} from "../../helpers/EventBus";
import Vue from 'vue';
import Message from "../../models/Messages/Message";
import SendingStatuses from "../../enums/SendingStatuses";
import sortBy from 'lodash.sortby'

export default {
    setRoom({commit}, room) {
        commit('setRoom', room);
    },
    resetRoom({commit}) {
        commit('setRoom', null);
        commit('setMessages', []);
    },
    async fetchMessages({ commit, state, rootGetters, dispatch }, params = {}) {
        let messages = [];
        try {
            if (params.initials) {
                messages = await fetchInitials(state.instance.id, params);
            } else {
                messages = await fetchMessages(state.instance.id, params);
            }
        }
        catch (e) {
            dispatch('reportException', e, {root: true});
        }

        const loadedUsers = rootGetters['chat/profiles/userIds'],
            userIds = uniq(messages.map(item => item.userID)).filter((item) => {
                return loadedUsers.indexOf(item) < 0;
            });

        if (userIds.length) {
            try {
                await dispatch('chat/profiles/fetchProfiles', userIds, {root: true});
            }
            catch (e) {
                dispatch('reportException', e, {root: true});
            }
        }

        const newMessages = params.initials ? sortBy(messages,  'createdAt') : sortBy(state.messages.concat(messages), 'createdAt');

        commit('setMessages', newMessages);
    },
    changeMessage({state, commit}, {messageId, newValues}) {
        const messageIndex = state.messages.findIndex(item => item.id == messageId);
        if (messageIndex >= 0) {
            state.messages[messageIndex] = new Message(Object.assign({}, state.messages[messageIndex], newValues));
        }
        commit('setMessages', [...state.messages]);
    },
    addMessage({commit, state, dispatch}, message) {
        state.messages.push(message);
        commit('setMessages', state.messages);
        dispatch('startTimer', message);
        if (state.instance.isHidden) {
            state.instance.isHidden = false;
        }
    },
    startTimer({commit,dispatch}, message) {
        const timer = setTimeout(() => {
            dispatch('chat/room/changeMessage', {messageId: message.id, newValues: {status: SendingStatuses.error}}, {root: true});
            commit('removeTimer',  message.id);
        }, 5000);
        commit('addTimer', {
            roomId: message.id,
            timerId: timer
        })
    },
    newMessage({commit, state}, message) {
        const timerId = message.localID || message.id;
        if (state.timers[timerId]) {
            clearTimeout(state.timers[timerId]);
            commit('removeTimer',  timerId);
        }
        if (state.instance && message.roomID == state.instance.id) {
            const founded = state.messages.findIndex((item) => {
                return item.localID == message.localID
            });
            if (founded < 0) {
                state.messages.push(message);
                EventBus.$emit('receiveMessage', message);
            }
            else {
                Vue.set(state.messages, founded, message);
            }
            commit('setMessages', state.messages);
        }
    },
    setIsMember({state, commit}, value) {
        if (state.instance) {
            const room = Object.assign({}, state.instance, {isMember: value});
            commit('setRoom', room);
        }
    },
    setIsSeen({state, commit}, messageIds) {
        state.messages.forEach((item) => {
            if (!item.isSeen && messageIds.indexOf(item.id) >= 0) {
                item.isSeen = true;
            }
        });
        commit('setMessages', [...state.messages]);
    }
}